import Operation from './Operation.js';

class DeleteEvent extends Operation {
    constructor(mix, event, inPlace=false) {
        super(mix, event.getType());

        this.event = event;
        this.inPlace = inPlace;
    }

    execute() {
        // first delete the event
        let index = this.events.indexOf(this.event);
        if (index > -1) {
            this.events.splice(index, 1);
        }

        if (!this.inPlace) {
            // then move all the proceeding events to the beginning
            // of the deleted event
            let duration = this.event.duration;
            for (let i in this.events) {
                if (this.events[i].step > this.event.step) {
                    this.events[i].step -= duration;
                    if (this.inPlace) {
                        return;
                    }
                }
            }
        }

        this.mix.restart();
    }
}

export default DeleteEvent;
 
